import statAlgorighmDeclarations from './StatAlgorithmDeclarations'
import * as Algorithms from './StatAlgorithms'

// Define and export algortihm selection function
export default (sportName, categoryName, statName) => {
  const sportCategories = statAlgorighmDeclarations[sportName]
  const category = sportCategories && sportCategories[categoryName]
  const algorithm = category && category[statName]

  // Allow for custom algorithm but default to average
  return algorithm || Algorithms.average
}



// WEBPACK FOOTER //
// ./src/utils/StatAlgorithm.js